// src/helpers/factories/mainScreenTables/tablesSorting.ts
var stringSortingValues = (a, b) => a > b ? 1 : a < b ? -1 : 0;
var iPairSortingValues = (a, b, extraValidation) => {
  const isRowANull = !a;
  const isRowBNull = !b;
  const isRowAAnArray = Array.isArray(a);
  const isRowBAnArray = Array.isArray(b);
  const isRowAEmptyArray = isRowAAnArray && a.length === 0;
  const isRowBEmptyArray = isRowBAnArray && b.length === 0;
  if (isRowANull && isRowBNull) {
    if (extraValidation) {
      return extraValidation();
    }
    return 0;
  }
  if (isRowANull && !isRowBNull && !isRowBEmptyArray) {
    return 1;
  }
  if (isRowBNull && !isRowANull && !isRowAEmptyArray) {
    return -1;
  }
  if (isRowANull && !isRowBNull && isRowBEmptyArray) {
    return -1;
  }
  if (isRowBNull && !isRowANull && isRowAEmptyArray) {
    return 1;
  }
  if (isRowAEmptyArray && isRowBEmptyArray) {
    if (extraValidation) {
      return extraValidation();
    }
    return 0;
  }
  if (isRowAAnArray && !isRowAEmptyArray && isRowBAnArray && isRowBEmptyArray) {
    return -1;
  }
  if (isRowBAnArray && !isRowBEmptyArray && isRowAAnArray && isRowAEmptyArray) {
    return 1;
  }
  const categorySubcategoryA = `${a[0].text} ${a[0].description}`;
  const categorySubcategoryB = `${b[0].text} ${b[0].description}`;
  return categorySubcategoryA > categorySubcategoryB ? 1 : categorySubcategoryA < categorySubcategoryB ? -1 : extraValidation ? extraValidation() : 0;
};
var nullUndefineSortingValues = (a, b) => {
  const isRowANull = a === null;
  const isRowBNull = b === null;
  const isRowAUndefined = a === void 0;
  const isRowBUndefined = b === void 0;
  const isRowAString = Boolean(a);
  const isRowBString = Boolean(b);
  if (isRowAUndefined && isRowBUndefined) {
    return 0;
  }
  if (isRowANull && isRowBNull) {
    return 0;
  }
  if (isRowANull && isRowBUndefined) {
    return -1;
  }
  if (isRowBNull && isRowAUndefined) {
    return 1;
  }
  if (!isRowAString && isRowBString) {
    return 1;
  }
  if (!isRowBString && isRowAString) {
    return -1;
  }
  return stringSortingValues(a, b);
};

export { iPairSortingValues, nullUndefineSortingValues, stringSortingValues };
